import { getWord } from "../helpers/translator";
import { getUser } from "./JwtService";

const NOTIFICATIONS_KEY = 'ar_notifications';
const NOTIFICATIONS_UPDATED_KEY = 'ar_notifications_updated';

export const getNotifications = (): any[] => {
    const user = getUser();
    const notificationsKey = `${NOTIFICATIONS_KEY}_${user?.id}`;
    const notificationsJson = window.localStorage.getItem(notificationsKey)
    if (notificationsJson) {
        return JSON.parse(notificationsJson);
    }
    return []
};

export const addNotification = (data: any) => {
    const user = getUser();
    const notificationsKey = `${NOTIFICATIONS_KEY}_${user?.id}`;
    const notificationsUpdatedKey = `${NOTIFICATIONS_UPDATED_KEY}_${user?.id}`;

    const existingNotifications = getNotifications();
    if (existingNotifications.length > 100) {
        const notifications = [data, ...existingNotifications.slice(0, 98)];
        window.localStorage.setItem(notificationsKey, JSON.stringify(notifications));
    }
    else {
        const notifications = [data, ...existingNotifications];
        window.localStorage.setItem(notificationsKey, JSON.stringify(notifications));
    }

    window.localStorage.setItem(notificationsUpdatedKey, "true");
}

export const newNotificationExists = (): boolean => {
    const user = getUser();
    const notificationsUpdatedKey = `${NOTIFICATIONS_UPDATED_KEY}_${user?.id}`;

    const stringValue = window.localStorage.getItem(notificationsUpdatedKey);
    if (stringValue && stringValue === 'true') {
        window.localStorage.setItem(notificationsUpdatedKey, "false");
        return true;
    }

    return false;
}

export const clearNotifications = () => {
    const user = getUser();
    const notificationsKey = `${NOTIFICATIONS_KEY}_${user?.id}`;
    const notificationsUpdatedKey = `${NOTIFICATIONS_UPDATED_KEY}_${user?.id}`;

    window.localStorage.removeItem(notificationsKey);
    window.localStorage.removeItem(notificationsUpdatedKey);
}